import { render } from "./GameType.vue?vue&type=template&id=5bde5d92"
import script from "./GameType.vue?vue&type=script&lang=js"
export * from "./GameType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__